import VuetableCheckboxStore from '../store';

module.exports = function() {
    if (this.opts.checkbox) {
        let store = `${this.name}_CHECKBOX`;

        if (this.$store.hasModule(store)) {
            return;
        }

        this.$store.registerModule(
            store,
            $.extend(true, {}, VuetableCheckboxStore),
        );
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/methods/register-checkbox-module.js